$(document).ready(() => {
  // Função para construção dos sliders
  function buildSlick(sliderWrapper, sliderOptions) {
    if (sliderWrapper.attr('data-autoplaysetting')) {
      const autoplaySetting = sliderWrapper.data('autoplaysetting');
      sliderOptions.autoplay = true;
      sliderOptions.autoplaySpeed = autoplaySetting;
    }

    sliderWrapper.slick(sliderOptions);
  }

  // Identificação dos wrapper de cada item do slide e suas opções
  // Banner principal da home
  var $mainSlider = [
    $('.hero__wrapper'),
    {
      fade: true,
      appendArrows: $('.hero .slide__nav'),
      speed: 500,
      responsive: [
        {
          breakpoint: 980,
          settings: {
            adaptiveHeight: true,
            arrows: false,
            dots: true,
          },
        },
      ],
    },
  ];

  //Novo banner principal da home
  var $mainSlider = [
    $('.carousel__home'),
    {
      fade: true,
      speed: 500,
      dots: true,
      adaptiveHeight: true,
      mobileFirst: true,
      dotsClass: 'dots-home',
      responsive: [
        {
          breakpoint: 980,
          settings: {
            adaptiveHeight: false,
          },
        },
      ],
    },
  ];

  // função pro vídeo ficar sempre do tamanho do item do carrossel, no mobile
  $('.carousel__home').on('init', (event, slick) => {
    if ($(window).width() < 600) {
      const heightSlide = $('.carosel__img-mobile').outerHeight();

      $('.item__video').css('height', heightSlide);
    }
  });

  $(window).resize(() => {
    if ($(window).width() < 600) {
      const heightSlide = $('.carosel__img-mobile').outerHeight();

      $('.item__video').css('height', heightSlide);
    }
  });
  //////////////////////////////////////////////////////////

  // Slide de publicidades da home
  const $adSlider = [
    $('.advertising__wrapper'),
    {
      centerMode: true,
      centerPadding: 0,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      speed: 500,
    },
  ];

  // Slide principal da home de benefícios
  const $vipSlider = [
    $('.hero__wrapper--vip'),
    {
      fade: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 980,
          settings: {
            arrows: false,
            dots: true,
          },
        },
      ],
    },
  ];

  // Slide para highlights do acontece em diversas páginas
  const $highlightsSlider = [
    $('.highlights__list'),
    {
      arrows: true,
      infinite: true,
      slidesToShow: 2,
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 740,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    },
  ];

  // Slide para highlights do fique por dentro em diversas páginas
  const $fiquepordentroSlider = [
    $('.fiquepordentro__list'),
    {
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 740,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    },
  ];

  const $eventsSlider = [
    $('.events__list'),
    {
      arrows: true,
      infinite: false,
      slidesToShow: 2,
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 980,
          settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    },
  ];

  // Carrossel de Aproveite sua visita na pagina de "Meus pedidos"
  const $aproveiteVisitaSlider = [
    $('.enjoy-your-visit__list'),
    {
      lazyLoad: 'progressive',
      dots: true,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      /* centerMode: true,
		centerPadding: '10px', */
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            dots: true,
            infinite: true,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 2,
            centerMode: false,
          },
        },
      ],
    },
  ];

  // Carrossel de Vitrine de Produtos na pagina de "Detalhes de Loja (e outras paginas)"
  const $vitrineProdutosSlider = [
    $('.product-showcase__list'),
    {
      lazyLoad: 'ondemand',
      dots: true,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            infinite: true,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 980, //min-width: 980
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
          },
        },
        {
          breakpoint: 600, //min-width: 980
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 2,
            arrows: false,
          },
        },
      ],
    },
  ];

  // Slide para cinema na home
  const $cinemaSlider = [
    $('.cinema__list'),
    {
      variableWidth: true,
      centerMode: true,
      centerPadding: 0,
      infinite: true,
      dots: true,
      responsive: [
        {
          breakpoint: 740,
          settings: {
            arrows: false,
            dots: true,
          },
        },
      ],
    },
  ];

  // Slide para acontece menu
  const $aconteceNewMenuSlider = [
    $('.acontece-new-menu__list'),
    {
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 740,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    },
  ];

  // Slide para Categorias da página de Fique por dentro
  const $categoriesSlider = [
    $('.inner-page__categories ul'),
    {
      arrows: false,
      infinite: false,
      slidesToShow: 2.7,
      dots: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            infinite: false,
            arrows: true,
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 600, //min-width: 600
          settings: {
            slidesToShow: 3,
            arrows: true,
          },
        },
      ],
    },
  ];

  const $stayOnTopSlider = [
    $('.inner-page__carousel__container ul'),
    {
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      dots: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            dots: true,
            infinite: true,
            arrows: true,
            slidesToShow: 1,
            //centerMode: false
          },
        },
      ],
    },
  ];

  // Slide para últimas notícias na página de detalhes
  const $innerPageCardsSlider = [
    $('.inner-page__cards__list.carousel'),
    {
      lazyLoad: 'progressive',
      dots: true,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1200, //min-width: 1200px
          settings: {
            infinite: true,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 740, //min-width: 740
          settings: {
            slidesToShow: 2,
            arrows: true,
          },
        },
      ],
    },
  ];

  const $shortcutsSlidesLength = $('.shortcuts-cards#redesign .shortcuts-cards__container a');
  // Slide menu atalho com imagens
  const $shortcutsSlides = [
    $('.shortcuts-cards#redesign .shortcuts-cards__container'),
    {
      infinite: false,
      dots: true,
      slidesToScroll: 2,
      slidesToShow: 2.5,
      autoplay: false,
      autoplaySpeed: 1000,
      arrows: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 979,
          settings: {
            dots: $shortcutsSlidesLength.length > 6,
            arrows: $shortcutsSlidesLength.length > 6,
            slidesToScroll: 3,
            slidesToShow: $shortcutsSlidesLength.length < 6 ? $shortcutsSlidesLength.length : 6,
          },
        },
        {
          breakpoint: 739,
          settings: {
            slidesToShow: 4.5,
          },
        },
        {
          breakpoint: 599,
          settings: {
            slidesToShow: 3.5,
          },
        },
      ],
    },
  ];

  // Construção dos Sliders
  buildSlick($mainSlider[0], $mainSlider[1]);
  buildSlick($adSlider[0], $adSlider[1]);
  buildSlick($vipSlider[0], $vipSlider[1]);
  buildSlick($highlightsSlider[0], $highlightsSlider[1]);
  buildSlick($fiquepordentroSlider[0], $fiquepordentroSlider[1]);
  buildSlick($cinemaSlider[0], $cinemaSlider[1]);
  buildSlick($aproveiteVisitaSlider[0], $aproveiteVisitaSlider[1]);
  buildSlick($vitrineProdutosSlider[0], $vitrineProdutosSlider[1]);
  buildSlick($categoriesSlider[0], $categoriesSlider[1]);
  buildSlick($stayOnTopSlider[0], $stayOnTopSlider[1]);
  buildSlick($innerPageCardsSlider[0], $innerPageCardsSlider[1]);
  buildSlick($shortcutsSlides[0], $shortcutsSlides[1]);
  buildSlick($eventsSlider[0], $eventsSlider[1]);
});
